var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"common__main-title"},[_vm._v("My Page")]),_c(_vm.currentDashboard,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }